import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const utimacoPacketSwitchTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Utimaco Packet Switch',
  key: 'utimacoPacketSwitchTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['AFID', 'CFID', 'LEA'],
          ['MCTYPE', 'IPADDR', 'PORT'],
          ['CCCMCID', 'ID', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      ID: {
        label: 'ID',
        type: 'text',
        initial: '',
        readOnly: true
      },
      AFID: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      CFID: {
        label: 'Collection Function Name',
        type: 'select',
        initial: 'z1sdd',
        options: [],
        validation: {
          required: true,
        },
      },
      LEA: {
        label: 'LEA',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select a value',
            value: ''
          }
        ],
        validation: {
          required: true,
        },
      },
      MCTYPE: {
        label: 'Monitoring Center Type',
        type: 'select',
        initial: 'TCP',
        options: [
          {
            label: 'TCP',
            value: 'TCP',
          }
        ],
        validation: {
          required: true,
        },
      },
      IPADDR: {
        label: 'IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      PORT: {
        label: 'AF Port',
        type: 'text',
        initial: '0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.',
            },
          ],
        },
      },
      CCCMCID: {
        label: 'Monitoring Center ID',
        type: 'text',
        initial: '',
        hide: 'true',
      },
    },
  },
};
